const TONES = {
  neutral: 'bg-surfaceAlt text-text',
  primary: 'bg-primaryMuted text-primary',
  success: 'bg-success/15 text-success',
  warning: 'bg-warning/15 text-warning',
  danger: 'bg-danger/15 text-danger',
  accent: 'bg-accentMuted text-accent',
};

export default function Badge({ tone = 'neutral', className = '', children, ...rest }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider ${
        TONES[tone] ?? TONES.neutral
      } ${className}`}
      {...rest}
    >
      {children}
    </span>
  );
}
